let util = {}

// getUUID：获取uuid
util.getUUID = function (len) {
  let chars = [...'0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz']
  if (!len && !parseInt(len)) len = 32

  let uuid = []
  while (len > 0) {
    uuid[--len] = chars[0 | Math.random() * chars.length]
  }
  return uuid.join('')
}

// 处理接口船舶数据
util.formatShipdata = function (o) {
  const ship = {...o}
  ship.cog = ship.cog / 100
  ship.hdg = ship.hdg / 100
  ship.draught = ship.draught / 1000
  ship.length = ship.length / 10
  ship.width = ship.width / 10
  ship.sog = ship.sog / 1000
  ship.lon = ship.lon / 1000000
  ship.lat = ship.lat / 1000000
  ship.lasttime = ship.lasttime * 1000
  return ship
}

export default util



// WEBPACK FOOTER //
// ./src/common/util.js